/** @format */

export const leadingZeroDoubleDigits = ['01', '02', '03', '04', '05', '06', '07', '08', '09'];
export const singleDigits = {
	low: ['1', '2', '3', '4'],
	all: ['1', '2', '3', '4', '5', '6', '7', '8', '9']
};
